import {
  getTextStyle,
  handleLabelFormatting,
  handleTooltipFormatting,
} from "../../utils";

export const horizontalRace = (
  props: Record<string, any> = {},
  data: Record<string, any> = {},
) => {
  const isMobile: boolean = window.innerWidth <= 768;
  const isLegend = props.showLegend && (data.series as unknown[]).length > 1;
  let gridOptions: { [key: string]: number } = {};
  const legendTextStyle = getTextStyle(props, "legend");
  const axisTextStyle = getTextStyle(props, "axis");
  const annotationTextStyle = getTextStyle(props, "annotation");

  let legendOptions: Record<string, any> = {
    show: isLegend,
    itemStyle:
      data.series.length === 1
        ? { color: "transparent", borderColor: props.color, borderWidth: 1 }
        : {},
    type: "scroll",
    itemGap: 16,
    textStyle: {
      ...legendTextStyle,
    },
  };
  const label: Record<string, unknown> = {
    show: props.showAnnotation,
    position: props.annotationPosition === "inside" ? "inside" : "right",
    formatter: (params: Record<string, string | number>) =>
      handleLabelFormatting(params, props.prefix, props.suffix),
    ...annotationTextStyle,
    valueAnimation: true,
    color:
      props.annotationPosition !== "inside"
        ? annotationTextStyle.color
        : undefined,
  };

  if (isLegend) {
    switch (props.legendPosition) {
      case "bottom":
        legendOptions = { ...legendOptions, bottom: 0 };
        gridOptions = { top: 48 };
        break;
      case "top":
        legendOptions = { ...legendOptions, top: 0 };
        gridOptions = { bottom: 48 };
        break;
    }
  } else {
    gridOptions = { top: 25, bottom: 25 };
  }

  return {
    yAxis: {
      type: "category",
      z: 10,
      data: data.titles || [],
      animationDuration: 300,
      animationDurationUpdate: 300,
      axisLabel: {
        hideOverlap: true,
        show: props.showAxisLabels,
        width: isMobile ? 50 : 100,
        overflow: "truncate",
        interval: 0,
        ...axisTextStyle,
      },
      tooltip: {
        show: true,
        padding: 4,
      },
    },
    tooltip: {
      formatter: (params: Record<string, string | number>) =>
        handleTooltipFormatting(params, props.prefix, props.suffix),
    },
    xAxis: {
      type: "value",
      boundaryGap: [0, 0],
      splitLine: {
        show: props.showGridlines,
        lineStyle: {
          color: props.darkMode ? "rgba(255, 255, 255, 0.15)" : "#E0E6F1",
        },
      },
      axisLabel: {
        hideOverlap: true,
        formatter: `${props.prefix ? props.prefix : ""}{value}${props.suffix ? props.suffix : ""}`,
        show: props.showAxisLabels,
        width: isMobile ? 50 : 100,
        overflow: "truncate",
        ...axisTextStyle,
      },
      tooltip: {
        show: true,
        padding: 4,
      },
    },
    title: {
      show: false,
    },
    textStyle: {
      color: props.color,
      fontFamily: props.fontFamily,
    },
    series: data.series || [],
    legend: legendOptions,
    animation: props.animation,
    label,
    animationDuration: 0,
    animationDurationUpdate: 3000,
    animationEasing: "linear",
    animationEasingUpdate: "linear",
    labelLayout: { hideOverlap: true },
    grid: { ...gridOptions, containLabel: true, left: 10 },
  };
};
